module.exports = __webpack_public_path__ + "img/img17.bb5f142c.png";